import { EventData, Work, EventLog, WorkItemList } from "../store/services/timelineApiRTK";

// Union type for all timeline items
export type TimelineItem = {
  id: string;
  type: 'eventdata' | 'work' | 'eventlog' | 'workitem';
  timestamp: string;
  data: EventData | Work | EventLog | WorkItemList;
};

// Timeline item with processed data
export interface ProcessedTimelineItem extends TimelineItem {
  title: string;
  description: string;
  icon: string;
  color: string;
  actionable?: boolean;
  metadata?: Record<string, unknown>;
}

// Timeline filter options
export interface TimelineFilters {
  showEventData: boolean;
  showWorks: boolean;
  showEventLogs: boolean;
  showWorkItems: boolean;
  dateRange?: {
    from: Date;
    to: Date;
  };
}

// Default filter state
export const defaultTimelineFilters: TimelineFilters = {
  showEventData: true,
  showWorks: true,
  showEventLogs: true,
  showWorkItems: true,
};